import { render, staticRenderFns } from "./SymposiumStage.vue?vue&type=template&id=6a9e9f03&scoped=true"
import script from "./SymposiumStage.vue?vue&type=script&lang=js"
export * from "./SymposiumStage.vue?vue&type=script&lang=js"
import style0 from "./SymposiumStage.vue?vue&type=style&index=0&id=6a9e9f03&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a9e9f03",
  null
  
)

export default component.exports